// Company details used on all printed documents. Edit freely.
export const COMPANY = {
  name: "Nisha Transport Corporation",
  brand: "",
  address: "No.12, Subash Chandra Bose 3rd Street, Ma.Po.Si Nagar, Gummidipoondi, Tamilnadu - 601201",
  gstin: "GSTIN: 33AGUPL9558L1ZF",
  pan: "PAN: AGUPL9558L",
  msme: "MSME No.: UDYAM-TN-24-0067205",
  phone: "Mobile: +91 93518 80118",
  mobile2: "93518 80118",
  email: "Email: chennai@ntclogistic.in",
  website: "www.ntclogistic.in",
};

// Head office contact for statement delivery (WhatsApp / Email)
export const HEAD_OFFICE = {
  whatsapp: "919351880118", // country code + number, digits only
  email: "chennai@ntclogistic.in",
};

// Tax-invoice specific info (bank, SAC, branch, terms)
export const BILL_INFO = {
  branch: "Chennai",
  sac_code: "996511",
  bank_lines: [
    "PUNJAB NATIONAL BANK, A/c No: 5978002100001357",
    "RTGS/NEFT, IFSC Code: PUNB0597800 Gummidipoondi",
  ],
  terms: [
    "Please Pay by A/c. Payee Cheque/DD/NEFT/RTGS Only.",
    "GST Payable by the Customer, As per Government Rules.",
    "GST Paid by Consignor or Consignee",
    "We are working under RCM, As per Government Rules.",
  ],
};
